import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Dialog } from '../ui/Dialog';

export function NewOfferDialog({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  function go(create: 'quotation' | 'both' | 'proposal') {
    onClose();
    navigate('/sales-offers/new', { state: { create } });
  }
  return (
    <Dialog title="New offer" onClose={onClose} footer={<Button variant="outline" onClick={onClose}>Cancel</Button>}>
      <p className="text-sm text-[var(--bo-muted)]">Choose what to create. Nothing is saved until you press Save.</p>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => go('quotation')}>Quotation only</Button>
        <Button onClick={() => go('both')}>Quotation and proposal</Button>
        <Button onClick={() => go('proposal')}>Proposal only</Button>
      </div>
    </Dialog>
  );
}
